module.exports = __webpack_public_path__ + "assets/b85.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b85.png
// module id = 677
// module chunks = 0